import { ButtonTypes } from '../enums/button-types.enum';

export const BUTTON_PARAMETER_FIELD_LABELS = {
  [ButtonTypes.Extension]: 'Select an Extension',
  [ButtonTypes.Park]: 'Select a Park Group',
  [ButtonTypes.Login]: 'Select a Group',
  [ButtonTypes.Flag]: 'Select a Service Flag',
  [ButtonTypes.Speed]: 'Enter a Number',
  [ButtonTypes.HuntGroup]: 'Select a Hunt Group',
  [ButtonTypes.AgentGroup]: 'Select an Agent Group / Call Queue',
};
